import moment from "moment";

export default ({coupon, until}) => `${coupon} until ${moment.unix(until).format('L')}`